import aichat from '../api/ai-chat'
import notifications from '../store/modules/notifications'

const api = {
  base: process.env.VUE_APP_BASE_PATH,
  merchant: {
    address: '/addresses',
    addressDetail: addressId => `/addresses/${addressId}`,
    deliveryServices: '/deliveryservices',
    nearestHub: '/logistic-hubs/nearest',
    orders: '/orders',
    users: '/merchant/users',
    userDetail: userId => `/merchant/users/${userId}`,
    registration: '/registration',
    setPassword: token => `/registration/${token}`,
    vouchers: '/vouchers',
    vouchersPagination: '/vouchers/pagination',
    statusActiveAPI: '/integrations/apikey/status',
    integrationApiKey: '/integrations/apikey/',
    integrationApiKeyDetail: '/integrations/apikey/detail',
    geocodingReverse: '/geocoding/reverse',
    mitraDetail: externalId => `/merchant/mitra/${externalId}`,
    updateMitra: externalId => `/merchant/mitra/${externalId}`
  },
  summary: {
    totalOrders: '/summary_reports/total_orders',
    logisticOrders: '/summary_reports/logistic_delivery_stats',
    expenses: '/summary_reports/expenses',
    paymentReports: '/payment_reports',
    paymentReportsDownload: '/payment_reports/download'
  },
  auth: {
    login: '/auth',
    logout: '/auth/session',
    forgotPassword: '/users/password/forgot',
    resetPassword: '/profile/default-password',
    changePassword: '/profile/change-password'
  },
  profile: '/profile',
  master: {
    package_sizes: '/package_sizes',
    cities: '/cities',
    deliveryServiceCodes: '/delivery-service-codes',
    paymentMethods: '/master/payment_methods',
    goodsCategories: '/goods_categories',
    bankCodes: '/master/bank_codes',
    ownershipTypes: '/master/ownership_types',
    vehicleTypes: '/master/vehicle_types',
    driverLicenseTypes: '/master/driver_license_types',
    province: '/master/indonesia/provinces',
    district: provinceId => `/master/indonesia/provinces/${provinceId}/districts`,
    subDistrict: (provinceId, districtId) => `/master/indonesia/provinces/${provinceId}/districts/${districtId}/subdistricts`,
    urbanVillage: (provinceId, districtId, subDistrictId) => `/master/indonesia/provinces/${provinceId}/districts/${districtId}/subdistricts/${subDistrictId}/urbanvillages`,
    pickupSlotTime: '/master/pickup_slot_time'
  },
  image: {
    upload: '/images/upload'
  },
  admin: {
    list: '/admins',
    detail: id => `/admins/${id}`
  },
  awb: awbNumber => `/awb/${awbNumber}`,
  ongkir: '/pricing',
  logisticProvider: '/logistic-providers',
  armada: {
    list: partnerId => `/partners/${partnerId}/vehicles`,
    detail: (partnerId, vehicleId) => `/partners/${partnerId}/vehicles/${vehicleId}`,
    history: (partnerId, vehicleId) => `/partners/${partnerId}/vehicles/${vehicleId}/drivers`,
    partner: partnerId => `/partners/${partnerId}/vehicle-partners`,
    partnerDetail: (partnerId, vehiclePartnerId) => `/partners/${partnerId}/vehicle-partners/${vehiclePartnerId}`,
    partnerVehicle: (partnerId, vehiclePartnerId) => `/partners/${partnerId}/vehicle-partners/${vehiclePartnerId}/vehicles`
  },
  order: {
    list: '/orders',
    uploadOrder: '/orders/upload-orders',
    tempOrderList: '/orders/temp-orders',
    createMultipleOrder: '/orders/create-multiple-orders',
    tempOrderDetail: tempOrderId => `/orders/temp-orders/${tempOrderId}`,
    detail: orderId => `/orders/${orderId}`,
    processOrder: orderId => `/orders/${orderId}/proceed`,
    rejectOrder: orderId => `/orders/${orderId}/reject`,
    retry: orderId => `/orders/${orderId}/payment/retry`,
    downloadShippingLabel: orderId => `/orders/${orderId}/waybill/download`,
    complain: orderId => `/orders/${orderId}/complain`,
    cancel: orderId => `/orders/${orderId}/cancel`,
    draftOrder: '/orders/draft',
    draftOrderCount: '/orders/draft/count',
    draftOrderDetail: draftOrderId => `/orders/draft/${draftOrderId}`,
    priceAdjustment: orderId => `/orders/${orderId}/price-adjustment`
  },
  courier: {
    list: '/couriers',
    detail: courierId => `/couriers/${courierId}`
  },
  hub: {
    list: partnerId => `/partners/${partnerId}/logistic-hubs`,
    detail: (partnerId, hubId) => `/partners/${partnerId}/logistic-hubs/${hubId}`
  },
  assignment: {
    pickup: `/pickup-assignments`,
    pickupDetail: pickupId => `/pickup-assignments/${pickupId}`,
    nearByCouriers: pickupId => `/pickup-assignments/${pickupId}/couriers/nearby`,
    assignCourier: pickupId => `/pickup-assignments/${pickupId}/couriers/assign`,
    driver: partnerId => `/partners/${partnerId}/vehicles/driver-assignments`
  },
  partner: {
    list: '/partners',
    detail: id => `/partners/${id}`,
    type: '/partner/types',
    package: id => `/partners/${id}/packages`,
    packageDetail: (partnerId, packageId) => `/partners/${partnerId}/packages/${packageId}`,
    costMapping: partnerId => `/partners/${partnerId}/cost_mappings`,
    costMappingDetail: (partnerId, costMappingId) => `/partners/${partnerId}/cost_mappings/${costMappingId}`,
    duplicateCostMapping: (partnerId, costMappingId) => `/partners/${partnerId}/cost_mappings/${costMappingId}/duplicate`,
    baseCost: (partnerId, costMappingId) => `/partners/${partnerId}/cost_mappings/${costMappingId}/base_costs`,
    baseCostDetail: (partnerId, costMappingId, baseCostId) => `/partners/${partnerId}/cost_mappings/${costMappingId}/base_costs/${baseCostId}`,
    vehicle: partnerId => `/partners/${partnerId}/vehicle-partners`
  },
  role: {
    permissionList: '/permissions',
    roles: '/roles',
    roleDetail: id => `/roles/${id}`
  },
  notifications: {
    unreadCount: '/notifications/unread',
    list: '/notifications',
    markAsRead: notificationId => `/notifications/read/${notificationId}`,
    markAllAsRead: '/notifications/read-all'
  },
  aichat: {
    sendMessage: '/ai-linknau/chat',
    getSessionHistories: '/ai-linknau/session-history',
    getMessages: '/ai-linknau/messages'
  }
}

export default api
